(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_8587b49"] && !Shopify.designMode) return;
  try {
    const section = document.getElementById('four-column-main');
    const counters = document.querySelectorAll('.counter-performance');
    let hasAnimated = false;

    function animateCounter(el, target, duration = 1500) {
      const start = 0;
      const startTime = performance.now();

      function update(currentTime) {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const value = Math.floor(progress * (target - start) + start);
        el.textContent = value + '%';
        if (progress < 1) requestAnimationFrame(update);
        else el.textContent = target + '%';
      }
      requestAnimationFrame(update);
    }

    function checkSectionInMiddle() {
      const rect = section.getBoundingClientRect();
      const sectionMiddle = rect.top + rect.height / 2;
      const viewportMiddle = window.innerHeight / 2;

      if (Math.abs(sectionMiddle - viewportMiddle) < 30 && !hasAnimated) {
        counters.forEach(counter => {
          const target = parseInt(counter.getAttribute('data-target'), 10);
          animateCounter(counter, target);
        });
        hasAnimated = true;
      }

      
    }

    window.addEventListener('scroll', checkSectionInMiddle);
  } catch(e) { console.error(e); }
})();

})();
